<template lang='pug'>
.address-panel-container
    .info(@click='$emit("clickInfo", recipient)')
        .man {{ recipient.name + " " + recipient.phone }}
        .area {{ address }}
        .detail {{ recipient.address.details }}
    .delete(@click="$emit('clickDelete',recipient)") 删除
</template>

<script>
export default {
    props: {
        recipient: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    computed: {
        address() {
            const ks = ['country', 'province', 'city', 'district']
            return ks.map(k => this.recipient.address[k]).join(' ')
        }
    }
}
</script>

<style scoped lang='less'>
.address-panel-container {
    margin-bottom: 1.2rem;
    display: flex;
    height: 5.6rem;
    border-radius: 0.2rem;
    background-color: #f3f3f3;;
    justify-content: space-between;
    padding:0.6rem 0.5rem 0.5rem 0.5rem;
    position: relative;
    .info {
        .detail {
            line-height: 1.2rem;
            color:#07448a;
            font-size: 0.6rem;
        }
    }
    .man{
        color: #07448a;
        line-height: 1rem;
        font-size: 0.7rem;
        margin-bottom: 0.3rem;
    }
    .area{
        font-size: 0.6rem;
        color:#07448a;
    }
    .delete{
        font-size:0.6rem ;
        height:0.85rem;
        color: #646464;
        position: absolute;
        line-height: 0.85rem;
        right:0.5rem;
        top:50%;
        transform: translateY(-50%);
    }
}
</style>